import { Vue } from 'vue-class-component';
export default class GridSquareLayout extends Vue {}